import configApi from '../apis/config'
import {
  local,
  KEY_FAMI_CONFIG,
  KEY_PALM_CONFIG,
  KEY_AREA_CONFIG,
  KEY_BNAK_CONFIG,
  KEY_HOLIDAYS_CONFIG,
  KEY_CONFIG_LAST_VERSION,
  KEY_DORM_ZONE_SWITCH_STATE,
  KEY_HILIFE_CONFIG,
  KEY_SEVEN_ELEVEN_CONFIG,
  KEY_ITEM_CATEGORIES_CONFIG
} from '../../tools/storage'
import { mapGeo } from '@/tools/strMap'
import sponorApi from '../apis/sponsor'

const state = {
  filterOptions: {
    need: {
      userRoleType: '',
      status: '',
      sort: '',
      category: '',
      randomSeed: '',
      isTraceUser: '',
      shipway: '',
      directPurchase: '',
      needSectionType: ''
    },
    gift: {
      isNew: '',
      status: '',
      orgFirst: '',
      sort: 'random',
      category: '',
      randomSeed: new Date().getTime(),
      isTraceUser: '',
      shipway: '',
      video: '',
      ongoing: ''
    },
    flash: {
      ongoing: '',
      sort: 'random',
      randomSeed: new Date().getTime(),
      video: ''
    },
    dorm: {
      isNew: '',
      status: '',
      orgFirst: '',
      sort: 'random',
      category: '',
      randomSeed: new Date().getTime(),
      isTraceUser: '',
      shipway: '',
      video: '',
      ongoing: ''
    },
    lovebox: {
      userRoleType: '',
      ongoing: '',
      isTraceUser: '',
      sort: '',
      category: ''
    }
  },
  mobileType: '',
  keywords: [],
  keywordsIdx: 0,
  userCategories: [],
  bonusRank: [],
  isWebView: false,
  showPreventDialog: false,
  taipeiBureauCurIdx: 1, // 台北社会局页面tab
  versions: {
    areas: '',
    banks: '',
    fami: '',
    palm: '',
    holidays: '',
    ibox_postboxes: '',
    hilife: '',
    seven_eleven: '',
    item_categories: ''
  },
  geoConfig: [],
  famiStores: [],
  palmBoxData: [],
  bankListData: [],
  holidays: [],
  // i 郵箱電子地圖（eMap）：最近一次選箱結果，供 EMapSelect 內部顯示 boxName / boxAddress
  emapLastPick: null,
  hilifeStores: [],
  sevenElevenStores: [],
  itemCategories: [],
  storyCategories: [],
  agreementConfig: '',
  privacyConfig: '',
  about543Config: '',
  heartWallWords: {
    data: [],
    currentPage: 0,
    lastPage: 1,
    total: 0,
    loading: false,
    sort: ''
  },
  defaultInvoiceDonate: null,
  dormZoneSwitch: false,
  utmSource: '',
  rulesFirstShown: {
    gift: false,
    need: false,
    flashGift: false,
    lovebox: false,
    commonwealNeed: false
  }
}

const actions = {
  getConfigVersion ({commit, state}) {
    let versions = local.get(KEY_CONFIG_LAST_VERSION, true)
    let currentTime = new Date().getTime()
    // 每天只獲取一次配置項的最新版本號
    if (versions &&
        currentTime - versions.time < 24 * 60 * 60 * 1000 &&
        currentTime - versions.time > 0) {
      commit('setVersions', versions.data)
    } else {
      configApi.getConfigVersions()
        .then(data => {
          commit('setVersions', data)
          local.save(KEY_CONFIG_LAST_VERSION, {time: currentTime, data})
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  getConfigInfo ({commit, state}, {cb, type}) {
    let localKey = {
      fami: KEY_FAMI_CONFIG,
      palm: KEY_PALM_CONFIG,
      areas: KEY_AREA_CONFIG,
      banks: KEY_BNAK_CONFIG,
      holidays: KEY_HOLIDAYS_CONFIG,
      hilife: KEY_HILIFE_CONFIG,
      seven_eleven: KEY_SEVEN_ELEVEN_CONFIG,
      item_categories: KEY_ITEM_CATEGORIES_CONFIG
    }[type]
    let data = local.get(localKey, true)
    if (data && state.versions[type] && data.version === state.versions[type]) {
      commit('setConfigInfo', {
        type,
        data: data && data.data
      })
      typeof cb === 'function' && cb(data.data)
    } else {
      configApi.getConfigInfo(type)
        .then((data) => {
          commit('setConfigInfo', {
            type,
            data: data && data.data
          })
          local.save(localKey, data)
          typeof cb === 'function' && cb(data && data.data)
        })
        .then(err => {
          console.log(err)
        })
    }
  },
  getGeoConfig ({dispatch, state}, {cb = null} = {}) {
    if (state.geoConfig && state.geoConfig.length) {
      typeof cb === 'function' && cb(state.geoConfig)
      return
    }

    dispatch('getConfigInfo', {cb, type: 'areas'})
  },
  getFamiStores ({dispatch, state}, {cb = null} = {}) {
    if (state.famiStores && state.famiStores.length) {
      typeof cb === 'function' && cb(state.famiStores)
      return
    }

    dispatch('getConfigInfo', {cb, type: 'fami'})
  },
  getPalmBox ({dispatch, state}, {cb = null} = {}) {
    if (state.palmBoxData && state.palmBoxData.length) {
      typeof cb === 'function' && cb(state.palmBoxData)
      return
    }

    dispatch('getConfigInfo', {cb, type: 'palm'})
  },
  getBankList ({dispatch, state}, {cb = null} = {}) {
    if (state.bankListData && state.bankListData.length) {
      typeof cb === 'function' && cb(state.bankListData)
      return
    }

    dispatch('getConfigInfo', {cb, type: 'banks'})
  },
  getHolidays ({dispatch, state}, {cb = null} = {}) {
    if (state.holidays && state.holidays.length) {
      typeof cb === 'function' && cb(state.holidays)
      return
    }

    dispatch('getConfigInfo', {cb, type: 'holidays'})
  },
  getHiLifeStores ({ dispatch, state }, { cb = null } = {}) {
    if (state.hilifeStores && state.hilifeStores.length) {
      typeof cb === 'function' && cb(state.hilifeStores)
      return
    }

    dispatch('getConfigInfo', {cb, type: 'hilife'})
  },
  getSevenElevenStores ({ dispatch, state }, { cb = null } = {}) {
    if (state.sevenElevenStores && state.sevenElevenStores.length) {
      typeof cb === 'function' && cb(state.sevenElevenStores)
      return
    }

    dispatch('getConfigInfo', { cb, type: 'seven_eleven' })
  },
  getItemCategories ({ commit, state }) {
    let data = local.get(KEY_ITEM_CATEGORIES_CONFIG, true)
    if (data && state.versions.item_categories && data.version === state.versions.item_categories) {
      commit('setCategories', { type: 'item', data: data.data })
      return new Promise((resolve, reject) => {
        resolve(data.data)
      })
    }
    return configApi.getItemCategories()
      .then(res => {
        commit('setConfigInfo', { type: 'item_categories', data: res.data.data })
        local.save(KEY_ITEM_CATEGORIES_CONFIG, res.data)
        return res.data.data
      })
      .catch(err => {
        console.log(err)
      })
  },
  getStoryCategories ({ commit }) {
    configApi.getStoryCategories()
      .then(data => {
        commit('setCategories', { type: 'story', data })
      })
      .catch(err => {
        console.log(err)
      })
  },
  getSubKeyW ({ commit }) {
    return configApi.getSubKeyW()
      .then(data => {
        commit('setSubKeyW', data)
        return data
      })
  },
  batchSubKeyW ({ commit }, { keywords }) {
    return configApi.batchSubKeyW(keywords)
      .then(res => {
        if (Array.isArray(res)) {
          commit('setSubKeyW', res)
        } else {
          commit('setSubKeyW', [])
        }
      })
  },
  getUserCategories ({commit, state}, {cb = null} = {}) {
    configApi.getUserCategories(
      (data) => {
        commit('setUserCategories', {data})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getBonusRank ({commit, state}, {cb = null} = {}) {
    configApi.getBonusRank(
      (data) => {
        commit('setBonusRank', {data})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getShareUrl ({ commit, state }, { para = {}, cb = null } = {}) {
    configApi.getShareUrl(
      para,
      data => cb(data)
    )
  },
  getAgreementConfig ({ commit }) {
    configApi.getAgreementConfig()
      .then(data => {
        commit('setStaticPageConfig', { content: data.data, type: 'agreement' })
        return data.data
      })
      .catch(err => console.log(err))
  },
  getPrivacyConfig ({ commit }) {
    configApi.getPrivacyConfig()
      .then(data => {
        commit('setStaticPageConfig', { content: data.data, type: 'privacy' })
        return data.data
      })
      .catch(err => console.log(err))
  },
  getAbout543Config ({ commit }) {
    configApi.getAbout543Config()
      .then(data => {
        commit('setStaticPageConfig', { content: data.data, type: 'about543' })
        return data.data
      })
      .catch(err => console.log(err))
  },
  getHeartWallWords ({ commit, state }, { page, perPage }) {
    commit('setHeartWallWordsLoading', true)
    return sponorApi.getSponsorGreetings(page, perPage || 20, state.heartWallWords.sort)
      .then(data => {
        commit('setHeartWallWords', { data: data.data })
        return data.data
      })
  },
  editHeartWallWord ({ commit }, { id, content }) {
    return sponorApi.modifySponsorGreeting(id, content)
      .then((data) => {
        commit('updateHeartWallWord', { id, content })
        return data.data
      })
  },
  voteHeartWallWords ({ commit }, { id }) {
    return sponorApi.voteSponsorGreeting(id)
      .then((data) => {
        commit('updateHeartWallWord', { ...data, voted: 1 })
        return data
      })
  },
  cancelVoteHeartWallWords ({ commit }, { id }) {
    return sponorApi.cancelVoteSponsorGreeting(id)
      .then((data) => {
        commit('updateHeartWallWord', { ...data, voted: 0 })
        return data
      })
  },
  getDefaultInvoiceDonate ({ commit }) {
    return configApi.getDefaultInvoiceDonate()
      .then((res) => {
        commit('setDefaultInvoiceDonate', res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  getDormZoneSwitchState ({ commit }) {
    let state = local.get(KEY_DORM_ZONE_SWITCH_STATE)
    if (state) {
      state = parseInt(state)
    } else {
      state = 0
    }
    commit('setDormZoneSwitchState', state)
    return configApi.getDormZoneSwitchState()
      .then((res) => {
        const switchState = parseInt(res.data)
        commit('setDormZoneSwitchState', switchState)
        local.save(KEY_DORM_ZONE_SWITCH_STATE, switchState)
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

const mutations = {
  toggleWebView (state, {value}) {
    console.log('enter mutation')
    console.log(value)
    state.isWebView = value
  },
  togglePreventLoginDialog (state, {value}) {
    state.showPreventDialog = value
  },
  setMobileType (state, {type}) {
    state.mobileType = type
  },
  setFilterOptions (state, payload) {
    state.filterOptions = {
      ...state.filterOptions,
      [payload.poolType]: {
        ...state.filterOptions[payload.poolType],
        ...payload
      }
    }
  },
  setGeoConfig (state, data) {
    state.geoConfig = data
  },
  setSubKeyW (state, data) {
    state.keywords = data
  },
  setUserCategories (state, data) {
    state.userCategories = data.data
  },
  setBonusRank (state, data) {
    state.bonusRank = data.data.week_bonus
  },
  setTaipeiBureauCurIdx (state, idx) {
    state.taipeiBureauCurIdx = idx
  },
  setKeywordsCurIdx (state, idx) {
    state.keywordsIdx = idx
  },
  setVersions (state, data) {
    state.versions = data
  },
  // i 郵箱電子地圖：EMapSelect 完成 consume 後把選箱結果寫進來，用來即時顯示箱名 / 地址
  setEMapLastPick (state, pick) {
    state.emapLastPick = pick
  },
  clearEMapLastPick (state) {
    state.emapLastPick = null
  },
  setConfigInfo (state, {type, data}) {
    switch (type) {
      case 'areas':
        state.geoConfig = data
        break
      case 'banks':
        state.bankListData = data
        break
      case 'fami':
        state.famiStores = data
        break
      case 'palm':
        state.palmBoxData = data
        break
      case 'holidays':
        state.holidays = data
        break
      case 'hilife':
        state.hilifeStores = data
        break
      case 'seven_eleven':
        state.sevenElevenStores = data
        break
      case 'item_categories':
        state.itemCategories = data
        break
      default:
        break
    }
  },
  setCategories (state, { type, data }) {
    state[`${type}Categories`] = data
  },
  setStaticPageConfig (state, { type, content }) {
    state[`${type}Config`] = content
  },
  setHeartWallWordsLoading (state, loading) {
    state.heartWallWords = {
      ...state.heartWallWords,
      loading
    }
  },
  updateHeartWallWord (state, data) {
    for (let i = 0; i < state.heartWallWords.data.length; ++i) {
      if (data.id === state.heartWallWords.data[i].id) {
        state.heartWallWords.data[i] = {
          ...state.heartWallWords.data[i],
          ...data
        }
      }
    }

    state.heartWallWords = {
      ...state.heartWallWords
    }
  },
  setHeartWallWords (state, { data }) {
    state.heartWallWords = {
      ...state.heartWallWords,
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total,
      data: data.current_page === 1 ? data.items : [
        ...state.heartWallWords.data,
        ...data.items
      ],
      loading: false
    }
  },
  setHeartWallWordsSort (state, sort) {
    state.heartWallWords.sort = sort
  },
  setDefaultInvoiceDonate (state, data) {
    state.defaultInvoiceDonate = data
  },
  setDormZoneSwitchState (state, switchState) {
    state.dormZoneSwitch = switchState
  },
  setUtmSource (state, source) {
    state.utmSource = source
  },
  setRulesFirstShown (state, { type }) {
    state.rulesFirstShown[type] = true
  }
}

export const getters = {
  famiPickerData: state => {
    if (state.famiStores.length) {
      return formatPickerData(state.famiStores)
    }
    return []
  },
  hilifePickerData: state => {
    if (state.hilifeStores.length) {
      return formatPickerData(state.hilifeStores)
    }
    return []
  },
  sevenElevenPickerData: state => {
    if (state.sevenElevenStores.length) {
      return formatPickerData(state.sevenElevenStores, 'store_addr', 'store_id', 'store_name')
    }
    return []
  },
  palmBoxPickerData: state => {
    if (state.palmBoxData.length) {
      var obj = {}
      state.palmBoxData.forEach(item => {
        if (!(item.CITYNAME in obj)) {
          obj[item.CITYNAME] = {}
          obj[item.CITYNAME][item.DICTNAME] = []
          obj[item.CITYNAME][item.DICTNAME].push(item)
        } else if (!(item.DICTNAME in obj[item.CITYNAME])) {
          obj[item.CITYNAME][item.DICTNAME] = []
          obj[item.CITYNAME][item.DICTNAME].push(item)
        } else if (item.DICTNAME in obj[item.CITYNAME]) {
          obj[item.CITYNAME][item.DICTNAME].push(item)
        }
      })
      var area = Object.keys(obj).map(key => ({name: key, value: key, parent: 0}))
      var city = Object.keys(obj).map(key => {
        return Object.keys(obj[key]).map(item => ({
          name: item,
          value: key + ' ' + item,
          parent: key
        }))
      }).reduce((pre, next) => [...pre, ...next])
      var palmbox = state.palmBoxData.map(item => ({
        name: `${item.THROWBUILDINGNAME} ${item.EDCODE}`,
        value: item.EDCODE,
        parent: item.CITYNAME + ' ' + item.DICTNAME
      }))
      var ary = [...area, ...city, ...palmbox]
      return ary
    }
    return []
  },
  itemCategoriesPickerData: state => {
    if (state.itemCategories.length) {
      let bigCategories = state.itemCategories.filter(item => item.level === 1)
        .map(item => ({
          name: item.title,
          value: item.id + '',
          parent: 0,
          ...item
        }))
      let midCategories = state.itemCategories.filter(item => item.level === 2)
        .map(item => ({
          name: item.title,
          value: item.id + '',
          parent: item.parent_id + '',
          ...item
        }))

      return [...bigCategories, ...midCategories]
    }

    return []
  },
  // i 郵箱電子地圖：最近一次選箱結果（server 回傳的 ADM_* 標準化格式）
  emapLastPick: state => state.emapLastPick,
  currentPalmBoxInfo: state => code => {
    if (code && state.palmBoxData.length) {
      return state.palmBoxData.find(item => item.EDCODE === code)
    }
    return ''
  },
  currentFamiStore: state => code => {
    if (code && state.famiStores.length) {
      return state.famiStores.find(item => item.code === code)
    }
    return ''
  },
  currentHilifeStore: state => code => {
    if (code && state.hilifeStores.length) {
      return state.hilifeStores.find(item => item.code === code)
    }
    return ''
  },
  currentSevenElevenStore: state => storeId => {
    if (storeId && state.sevenElevenStores.length) {
      return state.sevenElevenStores.find(item => item.store_id === storeId)
    }
    return ''
  },
  areaMapPickerData: state => {
    return mapGeo(state.geoConfig)
  },
  bankListPickerData: state => {
    return state.bankListData.map(v => {
      return {
        name: `${v.code} ${v.name}`,
        value: `${v.code} ${v.name}`
      }
    })
  },
  getBankFromCode: state => (bankCode) => {
    for (let item of state.bankListData) {
      if (item.code === bankCode) {
        return `${item.code} ${item.name}`
      }
    }
    return `無`
  },
  topLevelCategories: state => {
    if (state.itemCategories.length) {
      return state.itemCategories.filter(item => item.level === 1)
    }
    return []
  },
  getStoryCategoryById: state => id => {
    if (id && state.storyCategories.length) {
      let category = state.storyCategories.find(item => item.id === id)
      return category ? category.title : ''
    }
    return ''
  },
  getZipcodeByCityDistrict: state => (city, district) => {
    if (state.geoConfig.length) {
      let geo = state.geoConfig.find(item => item.city === city && item.district === district)
      return geo.code
    }

    return ''
  },
  isItemCategoriesLeaf: state => (categoryId) => {
    if (categoryId && state.itemCategories.length) {
      const category = state.itemCategories.find(item => item.id === parseInt(categoryId))
      if (!category) {
        return true
      }

      return category.carbon_coefficient != null
    }
    return true
  },
  getItemCategoryListById: state => (categoryId) => {
    if (categoryId && state.itemCategories.length) {
      const categories = state.itemCategories.filter(item => item.parent_id === parseInt(categoryId))
      return categories.map(item => ({
        name: item.title,
        value: item.id + ''
      }))
    }
    return []
  },
  getItemCategoryById: state => (categoryId) => {
    if (categoryId && state.itemCategories.length) {
      let category = state.itemCategories.find(item => item.id === parseInt(categoryId))

      return category
    }
    return null
  }
}

function formatPickerData (stores, addressField = 'address', codeField = 'code', nameField = 'name') {
  var ary = []
  var obj = {}
  ary = stores.map(item => {
    let newAdr = item[addressField].replace('臺', '台')
    const reg = new RegExp(/市|縣|鄉|鎮|區/)
    let area = ''
    let city = ''
    let matchItem = newAdr.match(reg)
    if (matchItem) {
      area = newAdr.slice(0, matchItem.index + 1)
      newAdr = newAdr.slice(matchItem.index + 1)
    }

    matchItem = newAdr.match(reg)
    if (matchItem) {
      city = newAdr.slice(0, matchItem.index + 1)
    }

    city = city.trim()
    area = area.trim()

    if (!(area in obj)) {
      obj[area] = []
      obj[area].push(city)
    } else if (obj[area].every(item => item !== city)) {
      obj[area].push(city)
    }

    return {
      name: item[nameField],
      value: item[codeField],
      parent: city,
      address: newAdr,
      area,
      city
    }
  })

  var areas = Object.keys(obj).map(key => ({
    name: key,
    value: key,
    parent: 0
  })).sort(function (a, b) { return a.name.localeCompare(b.name) })

  var cities = Object.keys(obj).map(key => {
    return obj[key].map(item => ({
      name: item,
      value: `${key}-${item}`,
      parent: key
    }))
  }).reduce((pre, next) => [...pre, ...next])

  var newStores = ary.map(item => ({
    value: item.value,
    name: `${item.value} ${item.name}`,
    parent: `${item.area}-${item.city}`,
    address: item[addressField]
  }))
  return [...areas, ...cities, ...newStores]
}

export default{
  state,
  actions,
  mutations,
  getters
}
